import type { ISablon } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/sablon-editoru/sablon.interface';

export const VARSAYILAN_WIDGETLER: ISablon[] = [
  {
    id: 'sys-saat',
    tur: 'widget',
    baslik: 'Saat',
    simge: '🕐',
    pozisyon: { genislik: 1, yukseklik: 1 },
    mod: 'serbest',
    arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #0d1b2a, #1b2838, #415a77)' },
    bolgeler: [],
    elementler: [],
    htmlModu: true,
    htmlIcerik: `<div class="saat-kutu">
  <div class="saat-buyuk">{{saat}}</div>
  <div class="saat-tarih">{{tarih}}</div>
</div>`,
    cssIcerik: `.saat-kutu { display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%; padding:8px; }
.saat-buyuk { font-size:28px; font-weight:700; font-family:'SF Mono',Consolas,monospace; color:#e0e7ff; letter-spacing:2px; }
.saat-tarih { font-size:11px; color:rgba(255,255,255,0.35); margin-top:4px; }`,
    veriKaynagi: {
      mod: 'hesaplama',
      piFunc: `
        var now = new Date();
        return {
          saat: now.toLocaleTimeString('tr-TR', {hour:'2-digit',minute:'2-digit',second:'2-digit'}),
          tarih: now.toLocaleDateString('tr-TR', {day:'2-digit',month:'2-digit',year:'numeric'})
        };
      `,
      yenilemeAraligi: 1,
    },
    kaynak: 'kod',
    sira: 0,
  },
  {
    id: 'sys-duyuru',
    tur: 'widget',
    baslik: 'Duyuru',
    simge: '📢',
    pozisyon: { genislik: 2, yukseklik: 1 },
    mod: 'serbest',
    arkaPlan: { tur: 'renk', deger: 'transparent' },
    bolgeler: [],
    elementler: [],
    stil: { gradyan: 'linear-gradient(135deg, #1a1a2e, #2d1b4e)', renkYazi: '#cbd5e1' },
    veriKaynagi: {
      mod: 'sabit',
      sabitVeri: { mesaj: 'FikoYT HMI Pano sistemine hoş geldiniz.' },
    },
    kaynak: 'kod',
    sira: 1,
  },
  {
    id: 'sys-uretim-sayac',
    tur: 'widget',
    baslik: 'Bugün Üretim',
    simge: '📊',
    pozisyon: { genislik: 1, yukseklik: 1 },
    mod: 'serbest',
    arkaPlan: { tur: 'renk', deger: 'transparent' },
    bolgeler: [],
    elementler: [],
    stil: { gradyan: 'linear-gradient(135deg, #064e3b, #10b981)', renkYazi: '#fff' },
    veriKaynagi: {
      mod: 'aggregate',
      pipeline: [
        { $match: { vt: 'FikoYT.sistem.hmi.uretim', silindi: { $ne: true }, $expr: { $gte: ['$olusturma', { $dateFromParts: { year: { $year: '$$NOW' }, month: { $month: '$$NOW' }, day: { $dayOfMonth: '$$NOW' } } }] } } },
        { $count: 'toplam' },
      ],
      yenilemeAraligi: 60,
      donusumFunc: `return { sayi: (veri && veri[0]) ? veri[0].toplam : 0 };`,
    },
    kaynak: 'kod',
    sira: 2,
  },
  {
    id: 'sys-bakim',
    tur: 'widget',
    baslik: 'Bekleyen Bakım',
    simge: '🛠️',
    pozisyon: { genislik: 1, yukseklik: 1 },
    mod: 'serbest',
    arkaPlan: { tur: 'renk', deger: 'transparent' },
    bolgeler: [],
    elementler: [],
    stil: { gradyan: 'linear-gradient(135deg, #7f1d1d, #dc2626)', renkYazi: '#fff' },
    veriKaynagi: {
      mod: 'aggregate',
      pipeline: [
        { $match: { _secilenSetId: 'hmi.bakim-talebi.ekle', silindi: { $ne: true }, 'veri.durum': { $in: ['bekliyor', 'planlandı'] } } },
        { $count: 'toplam' },
      ],
      yenilemeAraligi: 60,
      donusumFunc: `return { sayi: (veri && veri[0]) ? veri[0].toplam : 0 };`,
    },
    kaynak: 'kod',
    sira: 3,
  },
];
